<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/pest-step4')"></span>
    </div>
    <div class="title">请指定服务时间</div>
    <div class="notice-box" v-show="ifHoliday()">
	    <div class="notice-yellow">
	    	{{holidayWord()}}
	    </div>
    </div>

    <datepicker :inline="true" :language="zh" :monday-first="true" v-model="order.data.service_date"  :bootstrap-styling="true" :disabledDates="disabledDates" @selected="changeDate" :open-date="getOpenDate(order.data.service_date)"></datepicker>
    <div class="timerange" v-bind:class="{ visualhidden: !order.temp.isDate}">
      <div class="date">请选择时间段:</div>
      <div class="option-btn" @click="orderUpdate('service_period','am');changeTime('am')" v-bind:class="{ active: order.temp.isAM }">上午</div>
      <div class="option-btn" @click="orderUpdate('service_period','pm');changeTime('pm')" v-bind:class="{ active: order.temp.isPM }">下午</div>
    </div>
    <div class="call-info" :class="{ visualhidden: !(order.temp.isAM||order.temp.isPM)}">
      下单后我们客服将向您致电确定<span class="hl">具体时间</span>
    </div>
    <div class="btn-box-fix">
      <div class="btn-container">

        <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}">下一步</div>
      </div>
    </div>
    <img :src="pixelURL('pest','shijian')" class="hide">
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {zh} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'step5',
  components: {
    Datepicker
  },
  mounted: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "pest"){
        this.order = localParsed;
        let today=new Date();
        today = today.setHours(0, 0, 0, 0);

        let storageDate = this.order.data.service_date;
        var storageDate = new Date(storageDate).setHours(0, 0, 0, 0);
        if(storageDate<today || !storageDate){
          this.order.data.service_date = '';
          this.order.data.service_period = '';
          this.order.temp.isAM = '';
          this.order.temp.isAM = '';
          this.order.temp.isPM = '';
          this.order.temp.isDate = '';
        }
      }
      else{
        this.$router.push('/');
      }

    }
    else{
      this.$router.push('/');
    }
  },
  methods: {
    changeTime(time) {
      if(time == 'am'){
        this.order.temp.isAM=true;
        this.order.temp.isPM=false;
      }
      if(time == 'pm'){
        this.order.temp.isAM=false;
        this.order.temp.isPM=true;
      }
    },
    tomorrowDate: function () {
      let today = new Date();
      let tomorrow = new Date();
      tomorrow.setDate(today.getDate()+1);
      return tomorrow;
    },
    changeDate(){
      this.order.temp.isDate=true;
    },
    allFilled(){
        if(this.order.data.service_period && this.order.data.service_date){
            return true;
        }
    },
    checkSubmit(){
        if(this.allFilled()){
            this.orderUpdateAll('/pest-step6');
        }
        else{
            alert('请选择服务日期和时间')
        }
    }
  },
  data () {
    return {
      'order':{
        data:{
          date:'',
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:'',
        }
      },
      'address':{},
      zh: zh,
      disabledDates: {
        to: new Date(),
        ranges: [],
      }
    }
  },
  created: function () {
    this.disabledDates.ranges = this.DisabledDateRangesClean();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.weui-cells__title{
  margin-top:20px;
}

.timerange{
  text-align:center;
  margin-top:20px;
}

.date{
  color:#fe9567;
  display:inline-block;
  font-weight:600;
  font-size:1.1em;
  margin:0 10pt;
}

.option-btn{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  color:#ff7444;
  display:inline-block;
  margin:0 4px;
	text-align:center;
}

.option-btn.active{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  background-color:#fe9567;
  color:#fff;
  display:inline-block;
  margin:0 4px;
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

.call-info{
  text-align:center;
  color:#444;
  margin-top:14px;
  .hl{
    color:#fe9567;
  }
}

.container /deep/ .cell.selected{
  background:#EF885E;
  border-radius:30px;
  color:#fff;
}
.container /deep/ .vdp-datepicker__calendar .cell.selected:hover{
  background:#EF885E;
}

.container /deep/ .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover{
  border:0;
}

.container /deep/ .vdp-datepicker__calendar{
    border:0;
    padding:0 20pt;
    width:100%;
}

.container /deep/ .cell.selected:hover{
  border:solid 1px #EF885E;
}

.container /deep/ .cell:hover{
  border:solid 1px #EF885E;
}

</style>



// WEBPACK FOOTER //
// src/pages/pest/step5.vue